export default __webpack_public_path__ + "static/media/Cairo-Bold.fdde495f.ttf";